// removed by extract-text-webpack-plugin
module.exports = {"root":"clip-list__root","textList":"clip-list__textList clip-list__root","textListClip":"clip-list__textListClip","textListLink":"clip-list__textListLink","thumbList":"clip-list__thumbList clip-list__root","thumbListClip":"clip-list__thumbListClip"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/show-page/components/clip-list/styles.less
 ** module id = 434
 ** module chunks = 1
 **/